import * as React from 'react';
import * as ReactDOM from 'react-dom';
import { ButtonPill } from './button-pill';
import { SVGIcon } from './svg-icon';
import { classes, style } from 'typestyle';
import { horizontal, vertical } from 'csstips';
import { colorBackground, colorBrand, colorSlate, colorWhite } from '../theme/color';
import {em, percent, px, rem} from 'csx';
import { resetAnchorStyles } from '../theme/reset';

import Clipboard from 'clipboard';
import { mediaTablet, mediaMobileOnly } from '../theme/media';

export interface CopyBoxProps {
  className?: string;
  content: string;
}

export interface CopyBoxState {
  copied: boolean;
}

export class CopyBox extends React.Component<CopyBoxProps, CopyBoxState> {
  private _isMounted: boolean;
  private container: any;
  private content: any;
  private button: any;
  private clipboard: any;

  constructor(props) {
    super(props);
    this.state = { copied: false };
  }

  render() {
    const { content, className } = this.props;
    const { copied } = this.state;

    return (
      <div ref={el => this.container = el} className={classes(CopyBox.styles.container, className)}>
        <div ref={el => this.content = el}>{content}</div>
        <ButtonPill ref={el => this.button = el}>
          {!copied && <SVGIcon.Copy />}
          {copied && 'Copied!'}
        </ButtonPill>
      </div>
    )
  }

  componentDidMount() {
    const button = ReactDOM.findDOMNode(this.button);

    const options: any = {
      target: () => this.content,
      container: this.container
    };

    this.clipboard = new Clipboard(button, options);

    this.clipboard.on('success', e => {
      this.setState({ copied: true }, () => setTimeout(() => {
        if (this._isMounted) this.setState({ copied: false });
      }, 3000));
    });

    this.clipboard.on('error', e => {

    });

    this._isMounted = true;
  }

  componentWillUnmount() {
    if (this.clipboard) this.clipboard.destroy();

    this._isMounted = false;
  }

  static styles = {
    container: style(
      {
        ...horizontal,
        border: 0,
        color: colorSlate.toString(),
        background: colorBackground.toString(),
        borderRadius: '10px',
        $nest: {
          '&> div:first-child': {
            whiteSpace: 'pre-wrap',
            overflowX: 'auto',
            flex: 1,
            padding: '10px 15px',
            fontSize: rem(0.875),
            fontWeight: 400,
            lineHeight: em(1),
          },
          '&> div:last-child': {
            borderRadius: '0 10px 10px 0',
            padding: 0,
            width: px(80)
          }
        }
      }
    ),
    link: style({
      cursor: 'pointer',
      color: colorBrand.toString(),
      textDecoration: 'underline',
      $nest: {
        ...resetAnchorStyles(colorBrand.toString())
      }
    })
  }
}